(function(){
    if(window.__ssWebTiming)return;window.__ssWebTiming=1;
    if(!window.performance||!performance.getEntriesByType)return;
    var sent=false,lcp=0,fcp=0;
    try{new PerformanceObserver(function(l){var e=l.getEntries();if(e.length)lcp=e[e.length-1].startTime}).observe({type:"largest-contentful-paint",buffered:true})}catch(_){}
    try{new PerformanceObserver(function(l){l.getEntries().forEach(function(e){if(e.name==="first-contentful-paint")fcp=e.startTime})}).observe({type:"paint",buffered:true})}catch(_){}
    function send(){
      if(sent)return;sent=true;
      try{
        var n=performance.getEntriesByType("navigation")[0];if(!n)return;
        var b={nav:n.type,ssr:true};
        if(n.responseStart>0)b.ttfb=n.responseStart;
        if(n.domContentLoadedEventEnd>0)b.dcl=n.domContentLoadedEventEnd;
        if(n.loadEventEnd>0)b.load=n.loadEventEnd;
        if(fcp>0)b.fcp=fcp;
        if(lcp>0)b.lcp=lcp;
        var body=JSON.stringify(b);
        if(navigator.sendBeacon)navigator.sendBeacon("/api/load-timing",new Blob([body],{type:"application/json"}));
        else fetch("/api/load-timing",{method:"POST",headers:{"Content-Type":"application/json"},body:body,keepalive:true}).catch(function(){});
      }catch(_){}
    }
    function afterLoad(){setTimeout(send,1500)}
    if(document.readyState==="complete")afterLoad();else window.addEventListener("load",afterLoad);
    document.addEventListener("visibilitychange",function(){if(document.visibilityState==="hidden")send()});
    window.addEventListener("pagehide",send);
  })();